import { defineMessages } from "react-intl";

export const messages = defineMessages({
  createWebhook: {
    id: "wlr0Si",
    defaultMessage: "Create Webhook",
    description: "button",
  },
  action: {
    id: "a/QJBx",
    defaultMessage: "Action",
    description: "user action bar",
  },
  unnamedWebhook: {
    id: "Lm2Zw7",
    defaultMessage: "Unnamed webhook",
    description: "name placeholder",
  },
  noWebhooks: {
    id: "Bkxrhw",
    defaultMessage: "No webhooks found",
    description: "no webhooks message",
  },
});
